import React from 'react';
import { BUSINESS_TYPES } from '../../constants/businessTypes';

const BusinessTypePicker = ({ value = [], onChange, error }) => {
  const selected = Array.isArray(value) ? value : value ? [value] : [];

  const toggle = (id) => {
    if (selected.includes(id)) {
      onChange(selected.filter((x) => x !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div>
      <p className="block text-sm font-medium text-gray-700 mb-2">
        What does this business deal in? <span className="text-gray-400 font-normal">Select all that apply</span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {BUSINESS_TYPES.map((t) => {
          const on = selected.includes(t.id);
          return (
            <label
              key={t.id}
              className={`flex items-start gap-2.5 rounded-xl border px-3 py-2.5 cursor-pointer transition ${
                on ? 'border-blue-600 bg-blue-50 ring-1 ring-blue-600' : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <input
                type="checkbox"
                className="mt-0.5 h-4 w-4 text-blue-600 rounded border-gray-300"
                checked={on}
                onChange={() => toggle(t.id)}
              />
              <span className="text-sm font-medium text-gray-900">{t.name}</span>
            </label>
          );
        })}
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default BusinessTypePicker;
